import React from 'react';

import ConnectedField from './ConnectedField';
import UnconnectedField from './UnconnectedField';
import { withForm } from '../context';

export const Field = ({ form, ...rest }) => form ? (
    <ConnectedField form={form} {...rest} />
  ) : (
    <UnconnectedField {...rest} />
  );

export default withForm(Field);
